<template>
  <div>
<!-- Edit Assessment Control modals -->
    <b-modal ref="edit-question-1" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_description') }}
          </span>
        </div>

        <b-form-group>
          <label qid="create-q-name-label">
            {{ $t('maintenance.questions.create.name_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-input qid="create-q-form-name" type="text" v-model="form.name" required :maxLength="255"
            :placeholder="$t('maintenance.questions.create.name_placeholder')"></b-form-input>
        </b-form-group>

        <b-form-group>
          <label qid="create-q-reference-label">
            {{ $t('maintenance.questions.create.reference_label') }}
          </label>
          <b-form-input qid="create-q-form-reference" type="text" v-model="form.reference" :maxLength="255"
            :class="{ 'is-invalid': referenceInvalid }"
            :placeholder="$t('maintenance.questions.create.reference_placeholder')"></b-form-input>
          <b-form-invalid-feedback v-if="referenceInvalid" qid="pasword-requirement-notice" class="d-block">
            {{ $t('maintenance.questions.create.reference_error') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <label qid="create-assessment-control-objective-label">
            {{ $t('maintenance.control_objective.title') }}<span class="mandatory"> *</span>
          </label>
          <div class="multiselect-row">
            <multiselect v-model="selectedControlObjective" :options="controlObjectives"
              :placeholder="$t('maintenance.control_objective.title_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" required :allow-empty="false"
              @search-change="loadCO" track-by="id" qid="create-assessment-control-form-control-objective">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="book" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="book" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
            <b-button class="btn btn-secondary float-right" @click="showCreateControlObjectiveModal()"
              qid="control-objective-create-button-fc-modal" v-if="isGranted(permissions.CONTROL_OBJECTIVE_CREATE)"
              v-b-tooltip.hover :title="$t('maintenance.control_objective.add_new')">
              <font-awesome-icon icon="plus-circle" />
            </b-button>
          </div>
          <p v-if="form.control_objective && form.control_objective.name">
            <font-awesome-icon icon="book" />
            {{ form.control_objective.name }}
          </p>
        </b-form-group>
      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-active">1</li>
            <li class="progress-uncompleted">2</li>
            <li class="progress-uncompleted">3</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
            }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="hideEditQModal" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.cancel') }}
                </b-button>
                <b-button class="ml-3" variant="success" :disabled="buttonDisabled" @click="showEditQForm4('forward')"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- <b-modal ref="edit-question-2" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.linked_controls_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.linked_controls_description') }}
          </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success" qid="frameworkControl-create-button" @click="showAddLinkedControlModal">
                <font-awesome-icon icon="plus" /> {{ $t('generic_controls.linked_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t('generic_controls.linked_controls.name') }}
                </th>
                <th width="100"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in selectedLinkedControls" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <td scope="row">
                  <span v-if="item.assessment && item.assessment.name" class="text-muted">
                    {{ item.assessment.name }}
                  </span>
                  <br>
                  <span v-if="item && item.name">
                    <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                  </span>
                  <br>
                </td>
                <td>
                  <button class="btn btn-delete float-right" qid="delete-framework_control-modal"
                    @click="removeLinkedControlItem(index)">
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
              <tr v-for="(item, index) in selectedLinkedControlsAsTarget" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <td scope="row">
                  <span v-if="item.assessment_name" class="text-muted">
                    {{ item.assessment_name }}
                  </span>
                  <br>
                  <span v-if="item && item.name">
                    <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                  </span>
                  <br>
                </td>
                <td>
                </td>
              </tr>
              <tr v-if="!selectedLinkedControls.length && !selectedLinkedControlsAsTarget.length" qid="no-results-row"
                class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-active">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm1" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showEditQForm3('forward')" class="ml-3" variant="success" :disabled="buttonDisabled"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-3" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.framework_controls_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.framework_controls_description') }}
          </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success" qid="frameworkControl-create-button"
                @click="showAddFrameworkControlModal">
                <font-awesome-icon icon="plus" /> {{ $t('generic_controls.framework_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t('generic_controls.framework_controls.name') }}
                </th>
                <th width="100"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in selectedFrameworkControls" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <b-popover :target="'table-row-' + index" boundary="viewport" triggers="hover" placement="topleft"
                  :delay="{ show: 500, hide: 0 }">
                  <div v-if="item.active_framework && item.active_framework.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.active_framework_name_label') }}:
                    </span>
                    <br>
                    {{ item.active_framework.name }}
                    <br>
                  </div>
                  <div v-if="item.control_objective && item.control_objective.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.control_objective_name_label') }}:
                    </span>
                    <br>
                    {{ item.control_objective.name }}
                    <br>
                  </div>
                  <div v-if="item.control_objective && item.control_objective.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.control_objective_description_label') }}:
                    </span>
                    <br>
                    {{ item.control_objective.description | truncate(200) }}
                    <br>
                  </div>
                  <div v-if="item && item.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.framework_control.table.name') }}:
                    </span>
                    <br>
                    {{ item.name }}
                    <br>
                  </div>
                  <div v-if="item.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.framework_control.create.description_label') }}:
                    </span>
                    <br>
                    {{ item.description | truncate(200) }}
                    <br>
                  </div>
                </b-popover>
                <td scope="row">
                  <span v-if="item.active_framework && item.active_framework.name" class="text-muted">
                    {{ item.active_framework.name }}
                  </span>
                  <br>
                  <span>
                    {{ item.full_name }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-delete float-right" qid="delete-framework_control-modal"
                    @click="removeFrameworkControlItem(index)">
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
              <tr v-if="!selectedFrameworkControls.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-completed">2</li>
            <li class="progress-active">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm2" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showEditQForm4('forward')" class="ml-3" variant="success" :disabled="buttonDisabled"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal> -->

    <b-modal ref="edit-question-4" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_data_collection_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_data_collection_description') }}
          </span>
        </div>

        <div v-if="selectedTask.project && selectedTask.project.assessment.type == 'risk'">
          <h5>
            Data collection step is available only for global assessments. Press next to continue.
          </h5>
        </div>

        <div class="form-group" v-if="selectedTask.project && selectedTask.project.assessment.type != 'risk'">
          <label qid="create-q-data_collection-radio-label">
            {{ $t('maintenance.questions.create.data_collection_label') }}
          </label>
          <b-form-radio-group v-model="data_collection_on" :options="dataCollectionOptions"
            @change="lockSwitch(data_collection_on)" qid="create-q-data_collection-radio-option"></b-form-radio-group>
        </div>

        <div v-if="data_collection_on && selectedTask.project && selectedTask.project.assessment.type != 'risk'">
          <b-form-group>
            <label qid="create-q-data_collection-description-label">
              {{ $t('maintenance.questions.create.data_collection_description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-q-data_collection-form-description" v-model="form.data_collection_description"
              rows="6" max-rows="6" required
              :placeholder="$t('maintenance.questions.create.data_collection_description_placeholder')"></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>

            <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>

            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload ref="uploader" v-model="data_collection_files" :drop="true" :multiple="true"
                    input-id="uploader" name="uploader" @input="onFileChangeDataCollectionEdit"
                    @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showLinksSection = true">add links</span>
                </p>
              </div>

              <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection'">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                    qid="download-media">
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>

              <div v-if="selectedTask.links">
                <p v-for="(link, link_index) in getDataCollectionLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                    qid="view-q-remove-link">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>

          <b-form-group v-if="showLinksSection">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkDataCollection"
                :placeholder="$t('system.link')" qid="create-q-links"></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkNameDataCollection"
                :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                qid="create-q-links"></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0" id="inputGroup1" @click="handleEditDataCollectionLink"
                  qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-data_collection-description-label">
              {{ $t('maintenance.questions.create.data_collection_description_two_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-q-data_collection-form-description"
              v-model="form.data_collection_description_two" rows="6" max-rows="6" required
              :placeholder="$t('maintenance.questions.create.data_collection_description_two_placeholder')"></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>

            <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>

            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload ref="uploaderTwo" v-model="data_collection_two_files" :drop="true" :multiple="true"
                    input-id="uploaderTwo" name="uploaderTwo" @input="onFileChangeDataCollectionTwoEdit"
                    @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showLinksSectionTwo = true">add links</span>
                </p>
              </div>

              <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection_two'">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                    qid="download-media">
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>

              <div v-if="selectedTask.links">
                <p v-for="(link, link_index) in getDataCollectionTwoLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                    qid="view-q-remove-link">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>


          <b-form-group v-if="showLinksSectionTwo">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkDataCollection"
                :placeholder="$t('system.link')" qid="create-q-links"></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkNameDataCollection"
                :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                qid="create-q-links"></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0" id="inputGroup2"
                  @click="handleEditDataCollectionTwoLink" qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <!--Documentation Response-->
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_response_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="addResponseDoc" :options="allowTypesDoc"
              :placeholder="$t('maintenance.questions.create.add_response_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group v-if="addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>

            <multiselect v-model="responseTypeDoc" :options="responseTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              @select="handleTypeDoc" :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group
            v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptionsDoc" :key="index" class="mt-1 mb-1 pb-3 pt-3">
              <span class="float-right btn btn-delete" @click="removeOptionItemDoc(index, option)"
                qid="create-p-link-remove">
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect v-model="option.value" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input qid="create-p-form-link" type="text" v-if="showInputDoc"
                v-on:keydown.enter="handleOptionDoc" v-model="inputOptionDoc"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"></b-form-input>
              <div class="input-group-append" v-if="showInputDoc">
                <span class="input-group-text cursor-pointer" id="inputGroupDoc" @click="handleOptionDoc"
                  qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right" @click="showInputDoc = true" v-if="!showInputDoc"
              qid="create-p-add-link">
              <font-awesome-icon icon="plus" /> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group
            v-if="responseTypeDoc && responseTypeDoc.value === 'Yes/No' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect v-model="yesValueDoc" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">Yes</span>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect v-model="noValueDoc" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">No</span>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3"
            v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3"
            v-if="responseTypeDoc && responseTypeDoc.value !== 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_comment_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="dataCollectionAddDescription" :options="allowTypesShort"
              :placeholder="$t('maintenance.questions.create.add_comment_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="dataCollectionAddAttachments" :options="allowTypes"
              :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
        </div>
      </div>

      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-active">2</li>
            <li class="progress-uncompleted">3</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-completed">{{
              $t('maintenance.questions.create.documentation_collection_task')
            }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm1('back')"
                  qid="create-q-data_collection-back-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button class="ml-3" variant="success" @click="showEditQForm5('forward')" :disabled="buttonDisabled"
                  qid="create-q-data_collection-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal ref="edit-question-5" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_description_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_description_description') }}
          </span>
        </div>

        <b-form-group>
          <label qid="create-q-description-label">
            {{ $t('maintenance.questions.create.description_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-textarea qid="create-q-form-description" v-model="form.description" rows="6" max-rows="6" required
            :placeholder="$t('maintenance.questions.create.description_placeholder')"></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <div v-show="showDropActive" class="drop-active">
            <h3>
              {{ $t('tasks.modal.drop_files_to_upload_label') }}</h3>
          </div>
          <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>
          <div class="form-control auto-height pt-3 pb-3">
            <div class="text-center">
              <p>
                {{ $t('tasks.modal.drop_files_here_label') }}
                <file-upload ref="uploaderData" v-model="files" :drop="true" :multiple="true" input-id="uploaderData"
                  name="uploaderData" @input="onFileChangeEdit" @dropActive="showDropActiveFunction"
                  class="text-success cursor-pointer">
                  {{ $t('system.click_here') }}
                </file-upload>
                {{ $t('tasks.modal.upload_files_second_text') }}
                <span class="text-success cursor-pointer" @click="showQuestionLinksSection = true">add links</span>
              </p>
            </div>

            <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
              <span v-if="file.collection_name == 'question' || file.collection_name == 'documents'">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                  qid="remove-media-item">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                  qid="download-media">
                  <font-awesome-icon icon="cloud-download-alt" />
                </span>
                <a @click="downloadMedia(file)" qid="create-q-media-item">
                  {{ file.file_name }}
                </a>
              </span>
            </p>

            <div v-if="selectedTask.links">
              <p v-for="(link, link_index) in selectedTask.links" :key="link_index">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                  qid="view-q-remove-link">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-q-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="showQuestionLinksSection">
          <label qid="create-q-link-label">
            {{ $t('maintenance.third_parties.create.links_label') }}
          </label>

          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLink" :placeholder="$t('system.link')"
              qid="create-q-links"></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')" qid="create-q-links"></b-form-input>
            <div class="text-right mt-2">
              <span class="btn btn-success cursor-pointer mr-0" id="inputGroup3" qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
        </b-form-group>


        <b-form-group>
          <label qid="create-q-description-label">
            {{ $t('maintenance.questions.create.description_two_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-textarea qid="create-q-form-description" v-model="form.description_two" rows="6" max-rows="6" required
            :placeholder="$t('maintenance.questions.create.description_two_placeholder')"></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <div v-show="showDropActive" class="drop-active">
            <h3>
              {{ $t('tasks.modal.drop_files_to_upload_label') }}</h3>
          </div>
          <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>
          <div class="form-control auto-height pt-3 pb-3">
            <div class="text-center">
              <p>
                {{ $t('tasks.modal.drop_files_here_label') }}
                <file-upload ref="uploaderDataTwo" v-model="files_two" :drop="true" :multiple="true"
                  input-id="uploaderDataTwo" name="uploaderDataTwo" @input="onFileChangeEdit"
                  @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                  {{ $t('system.click_here') }}
                </file-upload>
                {{ $t('tasks.modal.upload_files_second_text') }}
                <span class="text-success cursor-pointer" @click="showQuestionTwoLinksSection = true">add links</span>
              </p>
            </div>

            <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
              <span v-if="file.collection_name == 'question_two'">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                  qid="remove-media-item">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                  qid="download-media">
                  <font-awesome-icon icon="cloud-download-alt" />
                </span>
                <a @click="downloadMedia(file)" qid="create-q-media-item">
                  {{ file.file_name }}
                </a>
              </span>
            </p>

            <div v-if="selectedTask.links">
              <p v-for="(link, link_index) in selectedTask.links_two" :key="link_index">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                  qid="view-q-remove-link">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-q-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="showQuestionTwoLinksSection">
          <label qid="create-q-link-label">
            {{ $t('maintenance.third_parties.create.links_label') }}
          </label>

          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLink" :placeholder="$t('system.link')"
              qid="create-q-links"></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')" qid="create-q-links"></b-form-input>
            <div class="text-right mt-2">
              <span class="btn btn-success cursor-pointer mr-0" id="inputGroup4" qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
        </b-form-group>





        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_response_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addResponse" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_response_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>

        <b-form-group v-if="addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.type_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="responseType" :options="responseTypes" group-values="items" group-label="group"
            :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>

        <b-form-group
          v-if="responseType && responseType.value == 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-p-link-label">
            {{ $t('maintenance.questions.create.options_label') }}
            <span class="text-red">*</span>
          </label>
          <p v-for="(option, index) in selectedOptions" class="mt-1 mb-1 pb-3 pt-3" :key="index">
            <span class="float-right btn btn-delete" @click="removeOptionItem(index, option)"
              qid="create-p-link-remove">
              <font-awesome-icon icon="trash-alt" />
            </span>
            <multiselect v-model="option.value" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="pt-2">{{ option.title }}</span>
          </p>
          <div class="input-group pt-2">
            <b-form-input qid="create-p-form-link" type="text" v-if="showInput" v-on:keydown.enter="handleOption"
              v-model="inputOption"
              :placeholder="$t('maintenance.questions.create.options_placeholder')"></b-form-input>
            <div class="input-group-append" v-if="showInput">
              <span class="input-group-text cursor-pointer" id="inputGroup5" @click="handleOption"
                qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
          <span class="btn btn-link cursor-pointer float-right" @click="showInput = true" v-if="!showInput"
            qid="create-p-add-link">
            <font-awesome-icon icon="plus" /> {{ $t('maintenance.questions.create.add_option_label') }}
          </span>
        </b-form-group>

        <b-form-group
          v-if="responseType && responseType.value == 'Yes/No' && addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-p-link-label">
            {{ $t('maintenance.questions.create.options_label') }}
            <span class="text-red">*</span>
          </label>
          <p class="mt-1 mb-1 pb-3 pt-3">
            <multiselect v-model="yesValue" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="mt-2">Yes</span>
          </p>
          <p class="mt-1 mb-1 pb-3 pt-3">
            <multiselect v-model="noValue" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="mt-2">No</span>
          </p>
        </b-form-group>

        <div class="text-muted mt-2 mb-3"
          v-if="responseType && responseType.value == 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          * {{ $t('maintenance.questions.create.helper_text_label') }}
        </div>
        <div class="text-muted mt-2 mb-3"
          v-if="responseType && responseType.value != 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
        </div>

        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_notes_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addNotes" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_notes_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_testing_notes_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addTestingNotes" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_testing_notes_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_control_description_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addControlDescription" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_control_description_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_performed_text_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addPerformedText" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_performed_text_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_description_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addDescription" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_description_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_attachments_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addAttachments" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
      </div>
      <b-form @submit="editFormSubmit" qid="create-q-form">
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-active">3</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>

              </li>
              <li class="text-center progress-completed">{{
                $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="" variant="secondary" @click="showEditQForm4('back')"
                    qid="create-q-data_collection-back-button">
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button type="submit" class="ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-q-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new linked control -->
    <b-modal ref="add-linked-control" hide-footer @hide="hideAddLinkedControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title text-white">
          {{ $t('generic_controls.linked_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length" show variant="danger" qid="create-io-error">
        {{ error }}
      </b-alert>
      <b-form @submit="linkedControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framework-control-pg-label ">
              {{ $t('generic_controls.linked_controls.create.framework_label') }}
            </label>
            <multiselect v-model="selectedAssessment" :options="assessmentItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.linked_controls.create.framework_placeholder')" label="name"
              @search-change="loadAssessmentItems" @select="handleAssessmentChange" track-by="slug"
              qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAssessment && selectedAssessment.id">
            <label qid="create-framework-control-pg-label">
              {{ $t('generic_controls.linked_controls.create.framework_control_label') }}
            </label>
            <multiselect v-model="selectedLinkedControl" :options="assessmentControlItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.linked_controls.create.framework_control_placeholder')"
              :custom-label="formatOptionLabel" @search-change="loadAssessmentControlItems" track-by="slug"
              qid="create-lb-form-pg"></multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.linked_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="secondary" @click="hideAddLinkedControlModal" qid="create-p-cancel-button">
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
            qid="create-p-submit-button">
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new framework control -->
    <b-modal ref="add-framework-control" hide-footer @hide="hideAddFrameworkControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('generic_controls.framework_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length" show variant="danger" qid="create-io-error">
        {{ error }}
      </b-alert>
      <b-form @submit="frameworkControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framewor-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_label') }}
            </label>
            <multiselect v-model="selectedFramework" :options="frameworkItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.framework_controls.create.framework_placeholder')" label="name"
              @search-change="loadFrameworkItems" @select="handleFrameworkChange" track-by="slug"
              qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedFramework && selectedFramework.id">
            <label qid="create-framewor-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_control_label') }}
            </label>
            <multiselect v-model="selectedFrameworkControl" :options="frameworkControlItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.framework_controls.create.framework_control_placeholder')"
              label="full_name" @search-change="loadFrameworkControlItems" track-by="id" qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.framework_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="secondary" @click="hideAddFrameworkControlModal" qid="create-p-cancel-button">
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
            qid="create-p-submit-button">
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new control objective -->
    <b-modal ref="add-control-objective" @hide="hideCreateControlObjectiveModal" modal-class="task-modal" hide-footer>

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateControlObjectiveModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="add-co-title">
            {{ $t('maintenance.control_objective.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="add-co-error">
        {{ error }}
      </b-alert>

      <b-form @submit="coFormSubmit" qid="create-co-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-control-objective-name-label">
              {{ $t('maintenance.control_objective.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input qid="create-control-objective-form-name" type="text" v-model="coForm.name" :maxLength="255"
              required :placeholder="$t('maintenance.control_objective.create.name_placeholder')"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-control-objective-description-label">
              {{ $t('maintenance.control_objective.create.description_label') }}
            </label>
            <b-form-textarea qid="create-control-objective-form-description" v-model="coForm.description" rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.control_objective.create.description_placeholder')"></b-form-textarea>
          </b-form-group>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="" variant="secondary" @click="hideCreateControlObjectiveModal"
                    qid="create-control-objective-cancel-button">
                    {{ $t('maintenance.control_objective.create.cancel') }}
                  </b-button>
                  <b-button type="submit" class="ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-control-objective-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('maintenance.control_objective.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>

    <ConfirmRemoveAttachment :object="selectedFile" :show="showDeleteAttachmentModal" type="file"
      @closeConfirmModal="closeDeleteAttachmentModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedFile" :task="selectedTask" :show="showDeleteLinkedAttachmentModal"
      type="linked_file" @closeConfirmModal="closeDeleteLinkedAttachmentModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedLink" :show="showDeleteLinkModal" type="link"
      @closeConfirmModal="closeDeleteLinkModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedComment" :task="selectedTask" :show="showDeleteCommentModal"
      type="comment" @closeConfirmModal="closeDeleteCommentModal"></ConfirmRemoveAttachment>

    <GuideViewModal :guide="selectedGuide" :showModal="viewGuideModal" @closeViewModal="closeViewGuideModal">
    </GuideViewModal>

    <ShowMoreModal :items="selectedItem.users" :show="showUsersModal" @closeViewModal="closeUsersModal" type="users">
    </ShowMoreModal>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Datepicker from 'vuejs-datepicker';
import Avatar from '@/components/Avatar.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModalEditQuestionWizard',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Datepicker,
    Avatar,
    UserInviteModal,
    ConfirmRemoveAttachment,
    GuideViewModal,
    ShowMoreModal
  }
};
</script>
